(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[47],{

/***/ "+uRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationFavorite", function() { return NavigationFavorite; });
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("LW0h");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7x/C");
/* harmony import */ var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("DZ+c");
/* harmony import */ var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("zjfJ");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("uDfI");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("wd/R");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _context_PageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("EkOT");
/* harmony import */ var _context_ReactAppContext__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("Ub5k");
/* harmony import */ var _utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("kNiU");
/* harmony import */ var _utils_ple_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("6jSF");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("z/9Z");
/* harmony import */ var urijs__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(urijs__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _local_storage_api__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("1RIK");
/* harmony import */ var _frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("qBqs");
/* harmony import */ var _frameworks_text_Text__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("qqKu");
/* harmony import */ var _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("SPKZ");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("UCZK");
/* harmony import */ var _product_banner_ProductBanner__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("SUcU");
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("kiXb");
/* harmony import */ var _frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("e0Ti");
/* harmony import */ var _frameworks_price_Price__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__("IuYR");
/* harmony import */ var _context_FavoriteProductListContext__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__("XGb2");
/* harmony import */ var _store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__("VO7D");
/* harmony import */ var _store_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__("+mhw");
/* harmony import */ var _store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__("fflk");
/* harmony import */ var _store_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__("C5R2");
/* harmony import */ var _store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__("1bWg");
/* harmony import */ var _tracking_constants__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__("829J");
/* harmony import */ var _tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__("sRdV");
/* harmony import */ var _tracking_utils__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__("zwLB");
/* harmony import */ var _utils_uri_constants__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__("Sj1w");
/* harmony import */ var _frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__("Ohju");
/* harmony import */ var _frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__("i5Mr");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__("1JJ2");






var __jsx = react__WEBPACK_IMPORTED_MODULE_6___default.a.createElement;































var NO_TRANSPORT_VALUE = _clubmed_utils__WEBPACK_IMPORTED_MODULE_14__["constants"].NO_TRANSPORT_VALUE;

var removeFromFavorites = function removeFromFavorites(indexToRemove, favoriteProductList, onClose, setFavoriteProductList) {
  var storeFavoriteProductList = favoriteProductList.filter(function (_, idx) {
    return idx !== indexToRemove;
  });
  storeFavoriteProductList.length ? Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* setInLocalStorage */ "c"])(_tracking_constants__WEBPACK_IMPORTED_MODULE_30__[/* SHOPPING_FAVORITE_PRODUCTS */ "r"], storeFavoriteProductList) : (Object(_local_storage_api__WEBPACK_IMPORTED_MODULE_15__[/* remove */ "b"])(_tracking_constants__WEBPACK_IMPORTED_MODULE_30__[/* SHOPPING_FAVORITE_PRODUCTS */ "r"]), onClose());
  setFavoriteProductList(storeFavoriteProductList, false, false);
};

var renderFavorite = function renderFavorite(favoriteProduct) {
  var _favoriteProduct$kids, _favoriteProduct$kids2, _favoriteProduct$pric;

  var hasTransport = favoriteProduct.departureCity && favoriteProduct.departureCity !== NO_TRANSPORT_VALUE;
  var formattedTripDuration = "".concat(favoriteProduct.departureDate && moment__WEBPACK_IMPORTED_MODULE_8___default()(favoriteProduct.departureDate).format('DD MMM'), " - ").concat(favoriteProduct.duration && moment__WEBPACK_IMPORTED_MODULE_8___default()(favoriteProduct.departureDate).add({
    days: favoriteProduct.duration
  }).format('DD MMM'), " ").concat(favoriteProduct.duration && "(".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.form.selectDuration', {
    duration: favoriteProduct.duration
  }), ")"));
  var formattedParticipants = "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.form.selectAdultsLabels', {
    count: favoriteProduct.adultsNumber
  })).concat(((_favoriteProduct$kids = favoriteProduct.kids) === null || _favoriteProduct$kids === void 0 ? void 0 : _favoriteProduct$kids.length) !== 0 ? " - ".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('booking.form.selectChildrenLabels', {
    count: (_favoriteProduct$kids2 = favoriteProduct.kids) === null || _favoriteProduct$kids2 === void 0 ? void 0 : _favoriteProduct$kids2.length
  })) : '');
  return __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx(_product_banner_ProductBanner__WEBPACK_IMPORTED_MODULE_20__[/* ProductBanner */ "a"], {
    className: "pb-5",
    theme: "small",
    reverse: true,
    product: favoriteProduct.product
  }), __jsx("div", {
    className: "flex justify-between items-center py-5"
  }, __jsx("span", {
    className: "flex items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].DATE,
    className: "ltr:mr-10 rtl:ml-10",
    width: "calc(16rem / 16)"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.dateLabel')), __jsx("span", null, formattedTripDuration)), __jsx("div", {
    className: "flex justify-between items-center py-5"
  }, __jsx("span", {
    className: "flex items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].PEOPLE_DOUBLE,
    className: "ltr:mr-10 rtl:ml-10",
    width: "calc(16rem / 16)"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.participantsLabel')), __jsx("span", null, formattedParticipants)), __jsx("div", {
    className: "flex justify-between items-center py-5"
  }, __jsx("span", {
    className: "flex items-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: hasTransport ? _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].TRANSPORT : _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].NO_TRANSPORT,
    className: "ltr:mr-10 rtl:ml-10",
    width: "calc(16rem / 16)"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.transportLabel')), __jsx("span", null, hasTransport ? favoriteProduct.departureCity : Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.transport.withoutTransportLabel'))), ((_favoriteProduct$pric = favoriteProduct.priceOfStay) === null || _favoriteProduct$pric === void 0 ? void 0 : _favoriteProduct$pric.bestPrice) && __jsx("div", {
    className: "mt-5 pt-10 border-t-1 flex items-start justify-between"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.price.totalLabel'), __jsx(_frameworks_price_Price__WEBPACK_IMPORTED_MODULE_23__[/* Price */ "a"], {
    bestPrice: favoriteProduct.priceOfStay.bestPrice,
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_19__[/* COLORS */ "a"].BLUE,
    initialPrice: favoriteProduct.priceOfStay.initialPrice,
    theme: "remote",
    instead: favoriteProduct.priceOfStay.bestPrice ? __jsx("span", {
      className: "font-sans text-12 text-darkGrey"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('price.format.from')) : '',
    containerStyle: {
      minHeight: 'auto'
    },
    className: "text-20 ltr:text-right rtl:text-left",
    hasAsterisk: false
  })));
};

var getPlaceholders = function getPlaceholders(numberOfItems) {
  var placeholders = [];

  for (var i = 0; i < numberOfItems; i++) {
    placeholders.push(__jsx("div", {
      key: i,
      style: {
        paddingBottom: 'calc(240 / 425 * 100%)'
      },
      className: "rounded-2 relative h-0 border-1 border-dashed border-grey my-20"
    }, __jsx("div", {
      className: "absolute inset-0 flex items-center justify-center text-center text-12 text-grey p-15"
    }, Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.allMyFavorites.emptyFavorites'))));
  }

  return placeholders;
};

var NoFavoritesView = function NoFavoritesView(_ref) {
  var onClose = _ref.onClose;
  return __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("div", {
    className: "text-12 mb-0 font-bold flex justify-between items-center"
  }, __jsx("span", {
    className: "ltr:pr-5 rtl:pl-5"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.noFavoritesPopin.title')), __jsx("button", {
    onClick: onClose,
    className: "leading-tighter",
    "data-testid": "CTA-close-no-favorite-view",
    type: "button"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].CROSS,
    width: "calc(13rem / 16)"
  }))), __jsx("div", {
    className: "text-12 p-25 pb-10 text-center"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].STAR_HOLLOW,
    width: "calc(32rem / 16)",
    className: "m-20"
  }), __jsx("div", null, Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.favoriteTooltip.title')), __jsx("div", {
    className: "text-darkGrey mt-25"
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.noFavoritesPopin.consult'))));
};

var LatestAddedProductView = function LatestAddedProductView(_ref2) {
  var favoriteProduct = _ref2.favoriteProduct,
      onButtonClick = _ref2.onButtonClick,
      onClose = _ref2.onClose;

  var _usePageContext = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_9__[/* usePageContext */ "b"])(),
      pageType = _usePageContext.pageType;

  return __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, __jsx("div", {
    className: "text-12 mb-0 font-bold flex justify-between items-center"
  }, __jsx("span", {
    className: "flex items-center ltr:pr-5 rtl:pl-5"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].CHECK,
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_19__[/* COLORS */ "a"].SUCCESS,
    width: "calc(14rem / 16)",
    className: "ltr:mr-10 rtl:ml-10"
  }), Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.favoritesPopin.title')), __jsx("button", {
    onClick: onClose,
    className: "leading-tighter",
    "data-testid": "CTA-close-favorite-view",
    type: "button"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].CROSS,
    width: "calc(13rem / 16)"
  }))), __jsx("div", {
    className: "mt-25 text-12"
  }, renderFavorite(favoriteProduct)), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_17__[/* Text */ "a"], {
    text: "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.favoritesPopin.reassuranceLabel')),
    theme: "none",
    className: "text-darkGrey text-center text-12 mt-10",
    innerClassName: "m-0"
  }), __jsx(_frameworks_button_Button__WEBPACK_IMPORTED_MODULE_22__[/* Button */ "a"], {
    className: "w-full mt-25",
    dataTestId: "CTA-see-all-favorite",
    onClick: onButtonClick,
    trackingData: {
      actionGA: 'header_favorites',
      labelGA: 'seeAllMyFavorites',
      categoryGA: 'headerMenu',
      pageName: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_32__[/* getSiteSection */ "e"])({
        pageType: pageType
      })
    }
  }, Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.favoritesPopin.button')));
};

var AllFavoriteProductView = function AllFavoriteProductView(_ref3) {
  var favoriteProductList = _ref3.favoriteProductList,
      numberOfProducts = _ref3.numberOfProducts,
      onClose = _ref3.onClose,
      setFavoriteProductList = _ref3.setFavoriteProductList,
      trackingData = _ref3.trackingData;
  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_7__[/* useDispatch */ "d"])();

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_36__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;

  var _useAppContext = Object(_context_ReactAppContext__WEBPACK_IMPORTED_MODULE_10__[/* useAppContext */ "c"])(),
      locale = _useAppContext.locale;

  var _usePageContext2 = Object(_context_PageContext__WEBPACK_IMPORTED_MODULE_9__[/* usePageContext */ "b"])(),
      pageType = _usePageContext2.pageType;

  var numberOfPlaceHolders = _tracking_constants__WEBPACK_IMPORTED_MODULE_30__[/* SHOPPING_FAVORITE_PRODUCTS_NUMBER_MAX */ "s"] - numberOfProducts;
  return __jsx(react__WEBPACK_IMPORTED_MODULE_6__["Fragment"], null, !isDesktop && __jsx("div", {
    className: "flex justify-end -mt-10"
  }, __jsx("button", {
    onClick: onClose
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].CROSS,
    width: "calc(16rem / 16)"
  }))), __jsx("div", {
    className: "rounded-2 p-15 my-20 shadow-subtle text-12"
  }, __jsx("div", {
    className: "flex items-center text-12"
  }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
    name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].STAR_HOLLOW,
    width: "calc(26rem / 16",
    className: "text-blue ltr:mr-20"
  }), __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_35__[/* default */ "a"], {
    className: "text-darkGrey cursor-default",
    onClick: function onClick() {
      trackingData({
        actionGA: 'header_favorites',
        labelGA: 'signIn',
        categoryGA: 'headerMenu',
        pageName: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_32__[/* getSiteSection */ "e"])({
          pageType: pageType
        })
      });
    },
    url: _utils_ple_utils__WEBPACK_IMPORTED_MODULE_12__[/* buildSigninUrl */ "f"]({
      locale: locale
    })
  }, __jsx(_frameworks_template_string_TemplateString__WEBPACK_IMPORTED_MODULE_34__[/* TemplateString */ "a"], {
    template: Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.allMyFavorites.incentive'),
    values: {
      signIn: Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.allMyFavorites.signIn')
    },
    valuesClassName: {
      signIn: 'text-blue underline cursor-pointer'
    }
  })))), __jsx(_frameworks_text_Text__WEBPACK_IMPORTED_MODULE_17__[/* Text */ "a"], {
    text: "".concat(Object(_i18n__WEBPACK_IMPORTED_MODULE_21__[/* t */ "h"])('common.favoriteOption.favoritesPopin.reassuranceLabel')),
    theme: "none",
    className: "text-darkGrey text-center text-12 py-5",
    innerClassName: "m-0"
  }), favoriteProductList.map(function (favoriteProduct, favoriteProductIndex) {
    var _URI$setQuery;

    var adultsNumber = favoriteProduct.adultsNumber,
        departureCity = favoriteProduct.departureCity,
        departureDate = favoriteProduct.departureDate,
        duration = favoriteProduct.duration,
        kids = favoriteProduct.kids,
        kidsValidationState = favoriteProduct.kidsValidationState,
        product = favoriteProduct.product;
    var resortPageUrl = new urijs__WEBPACK_IMPORTED_MODULE_13___default.a(product.href).setQuery((_URI$setQuery = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DEPARTURE_DATE */ "g"], departureDate && moment__WEBPACK_IMPORTED_MODULE_8___default()(departureDate).format(_utils_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DATE_FORMAT */ "f"])), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_DURATION */ "h"], duration), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_KIDS */ "j"], (kids === null || kids === void 0 ? void 0 : kids.length) > 0 && Object(_utils_faceting_facetingUtils__WEBPACK_IMPORTED_MODULE_11__[/* serializeKidsToQueryParam */ "o"])({
      kids: kids,
      kidsValidationState: kidsValidationState
    }) || undefined), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_NUMBER_OF_ADULTS */ "l"], adultsNumber), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(_URI$setQuery, _utils_uri_constants__WEBPACK_IMPORTED_MODULE_33__[/* QUERY_TRANSPORT */ "m"], departureCity), _URI$setQuery));
    return __jsx("div", {
      key: favoriteProductIndex,
      className: "rounded-2 p-15 my-20 shadow-subtle text-12"
    }, __jsx("div", null, __jsx("div", {
      className: "flex justify-end mb-15"
    }, __jsx("button", {
      "data-testid": "CTA-remove-favorite",
      onClick: function onClick() {
        removeFromFavorites(favoriteProductIndex, favoriteProductList, onClose, setFavoriteProductList);
        trackingData({
          actionGA: 'header_favorites',
          labelGA: 'removeFromFavorites',
          categoryGA: 'headerMenu',
          pageName: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_32__[/* getSiteSection */ "e"])({
            pageType: pageType
          })
        });
      },
      className: "leading-tighter",
      type: "button"
    }, __jsx(_frameworks_icon_Icon__WEBPACK_IMPORTED_MODULE_16__[/* Icon */ "a"], {
      name: _utils_icon_icons__WEBPACK_IMPORTED_MODULE_18__[/* ICONS */ "a"].CROSS,
      width: "calc(13rem / 16)"
    }))), __jsx(_frameworks_dynamic_link_DynamicLink__WEBPACK_IMPORTED_MODULE_35__[/* default */ "a"], {
      url: resortPageUrl.toString(),
      onClick: function onClick() {
        onClose();
        trackingData({
          actionGA: 'header_favorites',
          labelGA: "open_".concat(favoriteProduct.product.id),
          categoryGA: 'headerMenu',
          pageName: Object(_tracking_utils__WEBPACK_IMPORTED_MODULE_32__[/* getSiteSection */ "e"])({
            pageType: pageType
          })
        });
        Object(react_redux__WEBPACK_IMPORTED_MODULE_7__[/* batch */ "b"])(function () {
          dispatch(Object(_store_trip_information_adults_adults_action__WEBPACK_IMPORTED_MODULE_25__[/* setAdultsNumber */ "a"])(adultsNumber));
          dispatch(Object(_store_trip_criteria_departure_city_departureCity_action__WEBPACK_IMPORTED_MODULE_26__[/* setDepartureCity */ "a"])({
            value: departureCity
          }));
          dispatch(Object(_store_trip_criteria_departure_date_departureDate_action__WEBPACK_IMPORTED_MODULE_27__[/* setDepartureDate */ "a"])(departureDate));
          dispatch(Object(_store_trip_criteria_duration_duration_action__WEBPACK_IMPORTED_MODULE_28__[/* setDuration */ "a"])(duration));
          dispatch(Object(_store_trip_information_kids_kids_action__WEBPACK_IMPORTED_MODULE_29__[/* setKids */ "b"])(kids));
        });
      },
      className: "text-darkGrey"
    }, renderFavorite(favoriteProduct))));
  }), !!numberOfPlaceHolders && getPlaceholders(numberOfPlaceHolders));
};

var NavigationFavorite = function NavigationFavorite(_ref4) {
  var showcaseLatest = _ref4.showcaseLatest,
      onButtonClick = _ref4.onButtonClick,
      onClose = _ref4.onClose;

  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_6__["useContext"])(_context_FavoriteProductListContext__WEBPACK_IMPORTED_MODULE_24__[/* default */ "a"]),
      favoriteProductList = _useContext.favoriteProductList,
      setFavoriteProductList = _useContext.setFavoriteProductList;

  var numberOfProducts = favoriteProductList.length;
  var latestAddedProduct = favoriteProductList[numberOfProducts - 1];
  var track = Object(_tracking_tracking_api_useTracking__WEBPACK_IMPORTED_MODULE_31__[/* useTracking */ "a"])({});

  if (showcaseLatest && !!numberOfProducts) {
    return __jsx(LatestAddedProductView, {
      favoriteProduct: latestAddedProduct,
      onClose: onClose,
      onButtonClick: onButtonClick
    });
  }

  return numberOfProducts ? __jsx(AllFavoriteProductView, {
    favoriteProductList: favoriteProductList,
    numberOfProducts: numberOfProducts,
    onClose: onClose,
    setFavoriteProductList: setFavoriteProductList,
    trackingData: track
  }) : __jsx(NoFavoritesView, {
    onClose: onClose
  });
};

/***/ }),

/***/ "SUcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProductBanner; });
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wFPu");
/* harmony import */ var core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_reverse__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("cxan");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_product_product_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("C9cF");
/* harmony import */ var _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("UCZK");
/* harmony import */ var _frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("VHif");
/* harmony import */ var _exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Itgl");
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MWZw");



var __jsx = react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement;







var ICONS_HEIGHT_LARGE = 50;
var ICONS_HEIGHT_MEDIUM = 40;
var ICONS_HEIGHT_SMALL = 30;
var themes = {
  default: {
    iconHeight: ICONS_HEIGHT_LARGE,
    subtitleClassName: 'text-12',
    titleClassName: 'text-32'
  },
  medium: {
    iconHeight: ICONS_HEIGHT_MEDIUM,
    subtitleClassName: 'text-12',
    titleClassName: 'text-24'
  },
  small: {
    iconHeight: ICONS_HEIGHT_SMALL,
    subtitleClassName: 'text-12',
    titleClassName: 'text-24'
  }
};
var ProductBanner = function ProductBanner(_ref) {
  var _product$destination;

  var product = _ref.product,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      shouldHide = _ref.shouldHide,
      reverse = _ref.reverse,
      className = _ref.className;
  var _themes$theme = themes[theme],
      iconHeight = _themes$theme.iconHeight,
      subtitleClassName = _themes$theme.subtitleClassName,
      titleClassName = _themes$theme.titleClassName;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('items-start flex w-full lg:w-auto', className, {
      hidden: shouldHide,
      'flex-row-reverse': reverse
    })
  }, __jsx("div", {
    className: "flex"
  }, __jsx(_frameworks_badge_Badge__WEBPACK_IMPORTED_MODULE_7__[/* Badge */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])({}, Object(_utils_product_product_utils__WEBPACK_IMPORTED_MODULE_5__[/* getProductBadgeIcon */ "e"])(product), {
    className: "shrink-0 rounded-2",
    size: iconHeight
  })), product.isExplicitEC && product.badgeIcon && __jsx("span", {
    className: "font-brand mx-5 text-14 self-center"
  }, "&"), product.isExplicitEC && __jsx(_exclusive_collection_badge_ECBadge__WEBPACK_IMPORTED_MODULE_8__[/* ECBadge */ "a"], {
    height: iconHeight,
    iconWidth: "80%"
  })), __jsx("div", {
    style: {
      width: 'calc(10rem / 16)'
    }
  }), __jsx("div", {
    className: "flex-auto"
  }, __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_9__[/* Title */ "a"], {
    color: _utils_color_colors__WEBPACK_IMPORTED_MODULE_6__[/* COLORS */ "a"].DARK_GREY,
    hLevel: 1,
    theme: "none"
  }, __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('font-sans font-bold leading-tight uppercase', subtitleClassName)
  }, (_product$destination = product.destination) === null || _product$destination === void 0 ? void 0 : _product$destination.country), __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_4___default()('font-brand font-normal leading-tight', titleClassName)
  }, product.name))));
};

/***/ }),

/***/ "VO7D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setAdultsNumber; });
/* unused harmony export updateAdult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setAttendees; });
/* unused harmony export setAdults */
/* harmony import */ var _utils_createAction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rJ95");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ORYz");



function setAdultsNumber(adultsNumber) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_SET_ADULTS_NUMBER */ "e"], {
    adultsNumber: adultsNumber
  });
}

function updateAdult(index, valuesToUpdate) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* TRIP_INFORMATION_UPDATE_ADULT */ "f"], {
    index: index,
    valuesToUpdate: valuesToUpdate
  });
}

function setAttendees(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ATTENDEES */ "d"], payload);
}

function setAdults(payload) {
  return Object(_utils_createAction__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"])(_constants__WEBPACK_IMPORTED_MODULE_1__[/* SET_ADULTS */ "c"], payload);
}



/***/ })

}]);